import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const purposeListTodo = createAsyncThunk('purposeList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'purpose',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })

        return res

    } catch (error) {
        return error?.response
    }
});

const purposeListSlice = createSlice({
    name: 'purposeList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(purposeListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = []
            }
        });
        builder.addCase(purposeListTodo.rejected, (state, action) => {
        })
    }
});

export default purposeListSlice.reducer;


